import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ContributionRateCalculationType } from '../models/employers/enum/contribution-rate-calculation-type';

export function contributionRateCalculationTypeValidator(
  matchedTypeControlName: string,
  unmatchedTypeControlName: string
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.parent) return null;

    const matchedType = control.parent.get(matchedTypeControlName);
    const unmatchedType = control.parent.get(unmatchedTypeControlName);

    if (!matchedType || !unmatchedType) return null;

    const bothNotApplicable =
      matchedType.value === ContributionRateCalculationType.NA &&
      unmatchedType.value === ContributionRateCalculationType.NA;

    return bothNotApplicable ? { bothNotApplicable: true } : null;
  };
}
